import { render } from "./alldoctorsView.vue?vue&type=template&id=98f16d36&scoped=true"
import script from "./alldoctorsView.vue?vue&type=script&lang=js"
export * from "./alldoctorsView.vue?vue&type=script&lang=js"

import "./alldoctorsView.vue?vue&type=style&index=0&id=98f16d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f16d36"]])

export default __exports__